export default __webpack_public_path__ + "images/ZN.27b6cba.png";